import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import './Header.css';

const ServiceIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <path d="M14.7 6.3a4 4 0 0 1-5.4 5.4L4 17l1.7 1.7 5.4-5.3a4 4 0 0 1 5.4-5.4l-2.5 2.5-1.4-1.4 2.5-2.5z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
const TestDriveIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <circle cx="12" cy="12" r="8" />
        <path d="M12 4v3M12 17v3M4 12h3M17 12h3M7.5 7.5l2 2M14.5 14.5l2 2M16.5 7.5l-2 2M9.5 14.5l-2 2" strokeLinecap="round" />
    </svg>
);
const VisitIcon = () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <path d="M3 12l2-5.5A2 2 0 0 1 6.9 5h10.2a2 2 0 0 1 1.9 1.5L21 12" strokeLinecap="round" strokeLinejoin="round" />
        <rect x="3" y="12" width="18" height="6" rx="1.5" />
        <circle cx="7.5" cy="18" r="1.4" />
        <circle cx="16.5" cy="18" r="1.4" />
        <path d="M18 8l2-2M20 6h-2v2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const bookingLinks = [
    { label: 'Онлайн-запись на тест-драйв', to: '/test-drive-appointment', Icon: TestDriveIcon },
    { label: 'Онлайн-запись на сервис', to: '/service-appointment', Icon: ServiceIcon },
    { label: 'Онлайн-запись в отдел продаж', to: '/visit_showroom', Icon: VisitIcon },
];

// TODO: replace '#' with real routes once these pages exist
const serviceLinks = [
    { label: 'Промоакции и скидки', to: '#' },
    { label: 'Ремонт и обслуживание BMW', to: '#' },
    { label: 'Колеса и аксессуары', to: '#' },
    { label: 'Сервис и запчасти', to: '#' },
    { label: 'Кузовной ремонт', to: '#' },
    { label: 'Обслуживание и гарантия', to: '#' },
];

const navItems = [
    { label: 'Главное меню', to: '/' },
    {
        label: 'Автомобили BMW',
        children: [
            { label: 'BMW в наличии', to: '/catalog/new' },
            { label: 'BMW c пробегом', to: '/catalog/used' },
        ],
    },
    {
        label: 'Онлайн-запись',
        children: bookingLinks,
    },
    {
        label: 'Сервис и услуги',
        children: serviceLinks,
    },
    { label: 'Получить предложение', to: '/poluchit-predlozhenie' },
    { label: 'О нас', to: '/about' },
    { label: 'Контакты', to: '/contacts' },
];

const CarsPanelContent = ({ carsItem, onNavigate }) => (
    <div className="header-cars-panel">
        <div className="header-cars-hero">
            <div className="header-cars-hero-title">Выберите BMW</div>
            {/* Replace with your real hero image asset */}
            <img
                src="/assets/images/bmw-header-hero.webp"
                alt="BMW"
                className="header-cars-hero-image"
            />
            <Link to="/catalog/new" className="header-cars-hero-cta" onClick={onNavigate}>
                Узнайте больше
            </Link>
        </div>
        <div className="header-cars-links-row">
            {carsItem.children.map((child) => (
                <Link key={child.to} to={child.to} className="header-cars-link" onClick={onNavigate}>
                    <span>{child.label}</span>
                    <span className="header-cars-link-chevron">›</span>
                </Link>
            ))}
        </div>
        <div className="header-action-cards">
            {bookingLinks.map((action) => (
                <Link key={action.to} to={action.to} className="header-action-card" onClick={onNavigate}>
                    <span className="header-action-card-icon">
                        <action.Icon />
                    </span>
                    <span className="header-action-card-label">{action.label}</span>
                </Link>
            ))}
        </div>
    </div>
);

const ServicePanelContent = ({ onNavigate }) => (
    <div className="header-service-panel">
        <div className="header-service-top">
            <div className="header-service-promo">
                {/* Replace with your real promo image asset */}
                <img
                    src="/assets/images/bmw-service-promo.webp"
                    alt="Программа лояльности от официального сервиса BMW"
                    className="header-service-promo-image"
                />
                <div className="header-service-promo-caption">
                    ПРОГРАММА ЛОЯЛЬНОСТИ<br />ОТ ОФИЦИАЛЬНОГО СЕРВИСА BMW
                </div>
            </div>
            <div className="header-service-links">
                {serviceLinks.map((link) => (
                    <Link key={link.label} to={link.to} className="header-cars-link" onClick={onNavigate}>
                        <span>{link.label}</span>
                        <span className="header-cars-link-chevron">›</span>
                    </Link>
                ))}
            </div>
        </div>
        <div className="header-action-cards">
            {bookingLinks.map((action) => (
                <Link key={action.to} to={action.to} className="header-action-card" onClick={onNavigate}>
                    <span className="header-action-card-icon">
                        <action.Icon />
                    </span>
                    <span className="header-action-card-label">{action.label}</span>
                </Link>
            ))}
        </div>
    </div>
);

// Вертикальный список карточек "Онлайн-запись": иконка сверху, подпись снизу,
// разделитель между пунктами. Используется и на десктопе, и в мобильном drawer.
const BookingPanelContent = ({ items, onNavigate }) => (
    <div className="header-booking-list">
        {items.map((child) => (
            <NavLink
                key={child.to}
                to={child.to}
                className={({ isActive }) =>
                    `header-booking-item ${isActive ? 'is-active' : ''}`
                }
                onClick={onNavigate}
            >
                {child.Icon && (
                    <span className="header-booking-item-icon">
                        <child.Icon />
                    </span>
                )}
                <span className="header-booking-item-label">{child.label}</span>
            </NavLink>
        ))}
    </div>
);

const Header = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [mobileView, setMobileView] = useState('main'); // 'main' | 'cars' | 'booking' | 'service'
    const [activeIndex, setActiveIndex] = useState(null);
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const location = useLocation();
    const isCatalogPage = location.pathname.includes('/catalog');
    const isFormPage =
        location.pathname.includes('/visit_showroom') ||
        location.pathname.includes('/test-drive-appointment') ||
        location.pathname.includes('/service-appointment') ||
        location.pathname.includes('/poluchit-predlozhenie') ||
        location.pathname.includes('/appointment');

    useEffect(() => {
        const handleScroll = () => setIsScrolled(window.scrollY > 50);
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === 'Escape') setIsOpen(false);
        };
        if (isOpen) {
            window.addEventListener('keydown', handleEsc);
            document.body.style.overflow = 'hidden';
        }
        return () => {
            window.removeEventListener('keydown', handleEsc);
            document.body.style.overflow = '';
        };
    }, [isOpen]);

    const closeAll = () => {
        setIsOpen(false);
        setMobileView('main');
        setActiveIndex(null);
    };

    const handleSidebarClick = (item, i) => {
        if (item.children) {
            setActiveIndex(prev => (prev === i ? null : i));
        } else {
            closeAll();
        }
    };

    const headerBackground = (isScrolled || isCatalogPage || isFormPage)
        ? '#000'
        : 'linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 0%, transparent 100%)';

    const activeItem = activeIndex !== null ? navItems[activeIndex] : null;
    const carsItem = navItems.find(i => i.label === 'Автомобили BMW');
    const bookingItem = navItems.find(i => i.label === 'Онлайн-запись');
    const serviceItem = navItems.find(i => i.label === 'Сервис и услуги');
    const isCarsActive = activeItem === carsItem;
    const isServiceActive = activeItem === serviceItem;
    const isBookingActive = activeItem === bookingItem;

    const mobileViewFor = (item) => {
        if (item === carsItem) return 'cars';
        if (item === serviceItem) return 'service';
        return 'booking';
    };

    return (
        <>
            <header className="header" style={{ background: headerBackground }}>
                <div className="header-menu-trigger" onClick={() => setIsOpen(true)}>
                    <div className="header-line"></div>
                    <div className="header-line"></div>
                </div>
                {!isMobile && (
                    <div>
                        <Link to="/" className="header-logo-link">PREMIUM AUTO</Link>
                    </div>
                )}
                {!isMobile && (
                    <div className="header-lang-switch">
                        <span>РУССКИЙ</span> | <span>O'ZBEKCHA</span>
                    </div>
                )}
            </header>

            {/* ── Desktop: full-width top-drop panel, sidebar + content ── */}
            {!isMobile && (
                <>
                    <div className={`header-drawer ${isOpen ? 'header-drawer-open' : ''}`}>
                        <div className="header-drawer-sidebar">
                            <div className="header-drawer-header">
                                <Link to="/" className="header-mobile-drawer-logo" onClick={closeAll}>
                                    PREMIUM AUTO
                                </Link>
                                <div className="header-close-btn" onClick={() => setIsOpen(false)}>✕</div>
                            </div>
                            <nav className="header-nav">
                                {navItems.map((item, i) => (
                                    item.children ? (
                                        <div
                                            key={item.label}
                                            className={`header-nav-link header-nav-link-expandable ${i === activeIndex ? 'is-active' : ''}`}
                                            onClick={() => handleSidebarClick(item, i)}
                                        >
                                            <span>{item.label}</span>
                                            <span className="header-nav-chevron">›</span>
                                        </div>
                                    ) : (
                                        <Link
                                            key={item.label}
                                            to={item.to}
                                            className="header-nav-link"
                                            onClick={closeAll}
                                        >
                                            {item.label}
                                        </Link>
                                    )
                                ))}
                            </nav>
                            <div className="header-mobile-drawer-lang">
                                <span className="header-active-lang">РУССКИЙ</span>
                                <span>|</span>
                                <span>O'ZBEKCHA</span>
                            </div>
                        </div>
                        <div
                            className={`header-drawer-content ${activeItem ? 'is-visible' : ''} ${
                                (isCarsActive || isServiceActive || isBookingActive) ? 'is-light' : ''
                            }`}
                        >
                            {isCarsActive && (
                                <CarsPanelContent carsItem={carsItem} onNavigate={closeAll} />
                            )}
                            {isServiceActive && (
                                <ServicePanelContent onNavigate={closeAll} />
                            )}
                            {isBookingActive && (
                                <BookingPanelContent items={activeItem.children} onNavigate={closeAll} />
                            )}
                            {activeItem && !isCarsActive && !isServiceActive && !isBookingActive && (
                                <div className="header-drawer-sublist">
                                    {activeItem.children.map((child) => (
                                        <Link
                                            key={child.to}
                                            to={child.to}
                                            className="header-drawer-sublink"
                                            onClick={closeAll}
                                        >
                                            {child.Icon && (
                                                <span className="header-drawer-sublink-icon">
                                                    <child.Icon />
                                                </span>
                                            )}
                                            {child.label}
                                        </Link>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                    {isOpen && <div className="header-overlay" onClick={() => setIsOpen(false)}></div>}
                </>
            )}

            {/* ── Mobile: full-screen drawer, slides left → right ───── */}
            {isMobile && (
                <>
                    <div className={`header-mobile-drawer ${isOpen ? 'header-mobile-drawer-open' : ''}`}>
                        <div className="header-mobile-screens">
                            {/* Screen 1: main list */}
                            <div className={`header-mobile-screen ${mobileView !== 'main' ? 'is-hidden-left' : ''}`}>
                                <div className="header-drawer-header">
                                    <Link to="/" className="header-mobile-drawer-logo" onClick={closeAll}>
                                        PREMIUM AUTO
                                    </Link>
                                    <div className="header-close-btn" onClick={() => setIsOpen(false)}>✕</div>
                                </div>
                                <nav className="header-nav">
                                    {navItems.map((item) => (
                                        item.children ? (
                                            <div
                                                key={item.label}
                                                className="header-nav-link header-nav-link-expandable"
                                                onClick={() => setMobileView(mobileViewFor(item))}
                                            >
                                                <span>{item.label}</span>
                                                <span className="header-nav-chevron">›</span>
                                            </div>
                                        ) : (
                                            <Link
                                                key={item.label}
                                                to={item.to}
                                                className="header-nav-link"
                                                onClick={closeAll}
                                            >
                                                {item.label}
                                            </Link>
                                        )
                                    ))}
                                </nav>
                                <div className="header-mobile-drawer-lang">
                                    <span className="header-active-lang">РУССКИЙ</span>
                                    <span>|</span>
                                    <span>O'ZBEKCHA</span>
                                </div>
                            </div>

                            {/* Screen 2: Автомобили drill-down */}
                            <div className={`header-mobile-screen header-mobile-screen-sub is-light ${mobileView === 'cars' ? 'is-active' : ''}`}>
                                <div className="header-drawer-header">
                                    <div className="header-nav-back" onClick={() => setMobileView('main')}>
                                        ‹ <span>Автомобили</span>
                                    </div>
                                    <div className="header-close-btn" onClick={() => setIsOpen(false)}>✕</div>
                                </div>
                                <CarsPanelContent carsItem={carsItem} onNavigate={closeAll} />
                            </div>

                            {/* Screen 3: Онлайн-запись drill-down */}
                            <div className={`header-mobile-screen header-mobile-screen-sub is-light ${mobileView === 'booking' ? 'is-active' : ''}`}>
                                <div className="header-drawer-header">
                                    <div className="header-nav-back" onClick={() => setMobileView('main')}>
                                        ‹ <span>Онлайн-запись</span>
                                    </div>
                                    <div className="header-close-btn" onClick={() => setIsOpen(false)}>✕</div>
                                </div>
                                <BookingPanelContent items={bookingItem.children} onNavigate={closeAll} />
                            </div>

                            {/* Screen 4: Сервис и услуги drill-down */}
                            <div className={`header-mobile-screen header-mobile-screen-sub is-light ${mobileView === 'service' ? 'is-active' : ''}`}>
                                <div className="header-drawer-header">
                                    <div className="header-nav-back" onClick={() => setMobileView('main')}>
                                        ‹ <span>Сервис и услуги</span>
                                    </div>
                                    <div className="header-close-btn" onClick={() => setIsOpen(false)}>✕</div>
                                </div>
                                <nav className="header-nav header-nav-plain">
                                    {serviceLinks.map((link) => (
                                        <Link
                                            key={link.label}
                                            to={link.to}
                                            className="header-nav-link"
                                            onClick={closeAll}
                                        >
                                            {link.label}
                                        </Link>
                                    ))}
                                </nav>
                                <div className="header-action-cards">
                                    {bookingLinks.map((action) => (
                                        <Link
                                            key={action.to}
                                            to={action.to}
                                            className="header-action-card"
                                            onClick={closeAll}
                                        >
                                            <span className="header-action-card-icon">
                                                <action.Icon />
                                            </span>
                                            <span className="header-action-card-label">{action.label}</span>
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    {isOpen && <div className="header-overlay" onClick={() => setIsOpen(false)}></div>}
                </>
            )}
        </>
    );
};

// just text line for testing can be removed later 
// just text line for testing can be removed later 2
// just text line for testing can be removed later 3
// just text line for testing can be removed later 4

export default Header;